module.exports = __webpack_public_path__ + "static/media/La_Nota.45ed73f2.svg";